import { useRef } from "react";

export const Address = ({onInputChange, onInputBlur, onError}) => {

    const address  = useRef(null);

    const handleInputChange = () => {
        const name = address.current.name
        const value = address.current.value
        onInputChange({name: name, value: value});
    }

    const handleInputBlur = () => {
        const name = address.current.name
        const value = address.current.value
        onInputBlur({name: name, value: value});
    }

    return (
        <div className="mb-3">
            <label className="form-label fs-6 fw-bold">Адресса</label>
            <div className="input-group">
                <input ref={address} type="text"  className="form-control  border-dark" name="address" placeholder="Введіть адресу доставки" 
                    onChange={() => handleInputChange()}
                    onBlur={() => handleInputBlur()}
                />
            </div>
            {onError['address'] && <div className="error-message">{onError['address']}</div>} 
        </div>
    )
}
// 
// 